var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "box" },
    [
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.dialogVisible,
            "close-on-click-modal": false,
            title: _vm.popTitle,
            width: "1280px",
            top: "5vh",
            "custom-class": "dialog_box",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
            close: _vm.onClose,
          },
        },
        [
          _vm.componentCode == "local_topSearch"
            ? _c(
                "div",
                {
                  staticStyle: {
                    "border-bottom": "1px solid #DCDFE6",
                    "margin-bottom": "10px",
                  },
                },
                [
                  _c(
                    "el-form",
                    {
                      staticStyle: { width: "50%" },
                      attrs: { inline: false, "label-width": "100px" },
                    },
                    [
                      _c("el-form-item", { attrs: { label: "定位组件色：" } }, [
                        _c(
                          "div",
                          {
                            staticStyle: {
                              display: "flex",
                              "justify-content": "space-between",
                            },
                          },
                          [
                            _c("el-input", {
                              model: {
                                value: _vm.positionColor,
                                callback: function ($$v) {
                                  _vm.positionColor = $$v
                                },
                                expression: "positionColor",
                              },
                            }),
                            _vm._v(" "),
                            _c("el-color-picker", {
                              model: {
                                value: _vm.positionColor,
                                callback: function ($$v) {
                                  _vm.positionColor = $$v
                                },
                                expression: "positionColor",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticStyle: {
                              color: "#969696",
                              "font-size": "12px",
                            },
                          },
                          [_vm._v("默认颜色 #F8F8F8")]
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "搜索框样式:" } },
                        [
                          _c(
                            "el-radio-group",
                            {
                              model: {
                                value: _vm.borderStyle,
                                callback: function ($$v) {
                                  _vm.borderStyle = $$v
                                },
                                expression: "borderStyle",
                              },
                            },
                            [
                              _c("el-radio", { attrs: { label: 0 } }, [
                                _vm._v("胶囊型"),
                              ]),
                              _vm._v(" "),
                              _c("el-radio", { attrs: { label: 1 } }, [
                                _vm._v("圆角矩形"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "" } },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { type: "primary" },
                              on: { click: _vm.saveIt },
                            },
                            [_vm._v("保存")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "from_box" },
            [
              _vm.componentCode !== "local_topSearch"
                ? _c(
                    "el-form",
                    {
                      staticClass: "demo-ruleForm",
                      attrs: { inline: true, "label-width": "80px" },
                    },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "名称:" } },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请输入名称" },
                            model: {
                              value: _vm.title,
                              callback: function ($$v) {
                                _vm.title = $$v
                              },
                              expression: "title",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "是否启用:" } },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: { placeholder: "请选择" },
                              model: {
                                value: _vm.status,
                                callback: function ($$v) {
                                  _vm.status = $$v
                                },
                                expression: "status",
                              },
                            },
                            _vm._l(_vm.options, function (item) {
                              return _c("el-option", {
                                key: item.value,
                                attrs: { label: item.label, value: item.value },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { type: "primary" },
                              on: { click: _vm.search },
                            },
                            [_vm._v("查询")]
                          ),
                          _vm._v(" "),
                          _c("el-button", { on: { click: _vm.clear } }, [
                            _vm._v("重置"),
                          ]),
                          _vm._v(" "),
                          (_vm.componentCode == "diamond" &&
                            _vm.componentSubcode === "s_a") ||
                          _vm.componentCode == "banner"
                            ? _c(
                                "el-button",
                                {
                                  attrs: { type: "primary", plain: "" },
                                  on: { click: _vm.add },
                                },
                                [_vm._v("新增")]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                [
                  _c(
                    "el-table",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        "header-cell-style": { "text-align": "center" },
                        "cell-style": { "text-align": "center" },
                        data: _vm.tableData,
                        border: "",
                      },
                    },
                    [
                      _c("el-table-column", {
                        attrs: { label: "排序", width: "" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c("span", [_vm._v(_vm._s(scope.$index + 1))]),
                              ]
                            },
                          },
                        ]),
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { label: "图片", width: "" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _vm.componentCode != "diamond"
                                  ? _c("el-image", {
                                      staticStyle: { display: "block" },
                                      attrs: {
                                        src: scope.row.bannerPic
                                          ? scope.row.bannerPic
                                          : require("@/assets/customPage/" +
                                              (_vm.componentCode ===
                                              "local_topSearch"
                                                ? "l_ts"
                                                : _vm.componentSubcode) +
                                              "_" +
                                              (_vm.componentCode ===
                                              "local_topSearch"
                                                ? "icon"
                                                : scope.$index + 1) +
                                              ".png"),
                                        fit: "scale-down",
                                      },
                                    })
                                  : _c(
                                      "div",
                                      {
                                        staticStyle: {
                                          display: "flex",
                                          "justify-content": "center",
                                        },
                                      },
                                      [
                                        _c("el-image", {
                                          staticStyle: {
                                            display: "block",
                                            width: "40px",
                                            height: "40px",
                                          },
                                          attrs: {
                                            src: scope.row.bannerPic
                                              ? scope.row.bannerPic
                                              : require("@/assets/customPage/icon.png"),
                                            fit: "scale-down",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                              ]
                            },
                          },
                        ]),
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { label: "名称", width: "" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c("span", [
                                  _vm._v(_vm._s(scope.row.bannerName)),
                                ]),
                              ]
                            },
                          },
                        ]),
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { label: "跳转类型", width: "" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c("span", [
                                  _vm._v(_vm._s(scope.row.activityTypeName)),
                                ]),
                              ]
                            },
                          },
                        ]),
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { label: "活动名称", width: "" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c("span", [
                                  _vm._v(_vm._s(scope.row.activityName)),
                                ]),
                              ]
                            },
                          },
                        ]),
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { label: "是否启用", width: "" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c(
                                  "span",
                                  {
                                    style: {
                                      color: !scope.row.status
                                        ? "#999999"
                                        : "#333333",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(scope.row.status ? "启用" : "停用")
                                    ),
                                  ]
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { label: "创建时间", width: "180" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c("span", [
                                  _vm._v(_vm._s(scope.row.createTime)),
                                ]),
                              ]
                            },
                          },
                        ]),
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { label: "有效时间", width: "200" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c("div", [
                                  _vm._v(_vm._s(scope.row.startTime)),
                                ]),
                                _vm._v(" "),
                                _c("div", [_vm._v("~")]),
                                _vm._v(" "),
                                _c("div", [_vm._v(_vm._s(scope.row.endTime))]),
                              ]
                            },
                          },
                        ]),
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { label: "当前状态" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      display: "flex",
                                      "justify-content": "center",
                                      "align-items": "center",
                                    },
                                  },
                                  [
                                    _c(
                                      "span",
                                      {
                                        style: {
                                          color:
                                            _vm.realObj[scope.row.realStatus]
                                              .color,
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.realObj[scope.row.realStatus]
                                              .text
                                          )
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    scope.row.realStatus != 1
                                      ? _c(
                                          "el-tooltip",
                                          {
                                            staticClass: "item",
                                            attrs: {
                                              effect: "dark",
                                              content: scope.row.statusDesc,
                                              placement: "top",
                                            },
                                          },
                                          [
                                            _c("img", {
                                              staticStyle: {
                                                width: "16px",
                                                height: "16px",
                                                display: "block",
                                                margin: "0 0 2px 2px",
                                              },
                                              attrs: {
                                                src: _vm.realObj[
                                                  scope.row.realStatus
                                                ].src,
                                              },
                                            }),
                                          ]
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { label: "操作", width: "200" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c(
                                  "el-button",
                                  {
                                    attrs: {
                                      size: "mini",
                                      type: "primary",
                                      icon: "el-icon-edit",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.detail(scope.row)
                                      },
                                    },
                                  },
                                  [_vm._v("编辑")]
                                ),
                                _vm._v(" "),
                                (_vm.componentCode == "diamond" &&
                                  _vm.componentSubcode === "s_a") ||
                                _vm.componentCode == "banner"
                                  ? _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          size: "mini",
                                          type: "danger",
                                          icon: "el-icon-delete",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.del(scope.row)
                                          },
                                        },
                                      },
                                      [_vm._v("删除")]
                                    )
                                  : _vm._e(),
                              ]
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c("addBanner", { ref: "addBanner", on: { refresh: _vm.needRefresh } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }